import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';

function CountryListing({ cities }) {
  const sortedCities = cities.map((x) => x.fields.name.trim()).sort();

  const groupCities = () => {
    const groupCitiesByLetter = sortedCities.reduce((acc, value) => {
      const char = value.charAt(0).toUpperCase();
      acc[char] = [].concat(acc[char] || [], value);
      return acc;
    }, {});
    const citiesWithLetter = Object.keys(groupCitiesByLetter).map((el) => ({
      letter: el,
      cities: groupCitiesByLetter[el],
    }));
    return citiesWithLetter;
  };

  const citiesGroupedByLetter = groupCities();
  const alpha = Array.from(Array(26)).map((e, i) => i + 65);
  const alphabet = alpha.map((x) => String.fromCharCode(x));

  const findSlugByCity = (cityName) =>
    cities.find((city) => city.fields.name.trim() === cityName).fields.slug;

  return (
    <>
      {alphabet.map((letter) => (
        <>
          <Typography variant="h4" py={4}>
            {letter}
          </Typography>

          <Grid container spacing={4}>
            {(
              citiesGroupedByLetter.find((x) => x.letter === letter)?.cities ||
              []
            ).map((city) => (
              <Grid item lg={6} md={6} sm={6} xs={12} key={city.objectID}>
                <StyledLink href={`/catering-${findSlugByCity(city)}`}>
                  <StyledBox>
                    <Typography variant="h6">{city}</Typography>
                  </StyledBox>
                </StyledLink>
              </Grid>
            ))}
          </Grid>
        </>
      ))}
    </>
  );
}

const StyledLink = styled.a`
  text-decoration: inherit;
  color: inherit;
  cursor: pointer;
`;

const StyledBox = styled(Box)`
  padding: ${(props) => props.theme.spacing(2, 4)};
  box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);
  text-align: center;
  border-radius: ${(props) => props.theme.spacing(1)}px;

  &:hover {
    background: ${(props) => props.theme.palette.text.disabled};
  }
`;

export default CountryListing;
